var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaravan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M503.172,308.966h-88.276c-4.873,0-8.828-3.946-8.828-8.828s3.955-8.828,8.828-8.828h88.276 c4.873,0,8.828,3.946,8.828,8.828S508.045,308.966,503.172,308.966L503.172,308.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M467.862,308.966c-4.873,0-8.828-3.946-8.828-8.828v-35.31c0-4.882,3.955-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v35.31C476.69,305.02,472.735,308.966,467.862,308.966"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE5D"
    },
    d: "M423.724,300.138H0V78.336c0-14.009,11.361-25.37,25.37-25.37h372.983 c14.009,0,25.37,11.361,25.37,25.37V300.138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5B5B"
    },
    d: "M379.586,406.069c0,29.255-23.711,52.966-52.966,52.966s-52.966-23.711-52.966-52.966 s23.711-52.966,52.966-52.966S379.586,376.814,379.586,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5B5B"
    },
    d: "M150.069,406.069c0,29.255-23.711,52.966-52.966,52.966s-52.966-23.711-52.966-52.966 s23.711-52.966,52.966-52.966S150.069,376.814,150.069,406.069"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M114.759,406.069c0,9.754-7.901,17.655-17.655,17.655s-17.655-7.901-17.655-17.655 s7.901-17.655,17.655-17.655S114.759,396.314,114.759,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M344.276,406.069c0,9.754-7.901,17.655-17.655,17.655c-9.754,0-17.655-7.901-17.655-17.655 s7.901-17.655,17.655-17.655C336.375,388.414,344.276,396.314,344.276,406.069"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#419EDE"
    },
    d: "M0,300.138v83.871c0,12.182,9.878,22.06,22.06,22.06h22.078c0-29.255,23.711-52.966,52.966-52.966 s52.966,23.711,52.966,52.966h123.586c0-29.255,23.711-52.966,52.966-52.966s52.966,23.711,52.966,52.966h44.138V300.138H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C49E47"
    },
    d: "M0,220.69h132.414c4.873,0,8.828-3.946,8.828-8.828c0-4.882-3.955-8.828-8.828-8.828H0V220.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C49E47"
    },
    d: "M0,176.552h97.103c4.873,0,8.828-3.946,8.828-8.828s-3.955-8.828-8.828-8.828H0V176.552z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravan);
export default __webpack_public_path__ + "static/media/caravan.0bfed05474f3aefc96edd7f4c5a69359.svg";
export { ForwardRef as ReactComponent };